var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"SupplierCard"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('CardBasicInfoBlock',{attrs:{"data":{
          thumbnail: _vm.supplier.logo,
          title: _vm.supplier.display_name,
          action: _vm.showSupplierDetails,
          actionText: _vm.$t('supplierCardContactDetailsButton'),
        }}})],1)]),_c('el-dialog',{attrs:{"visible":_vm.supplierDetailsIsVisible,"title":_vm.$t('contactDetailsPreviewModalTitle')},on:{"update:visible":[function($event){_vm.supplierDetailsIsVisible=$event},_vm.hideSupplierDetails]}},[_c('SupplierDetails',{attrs:{"supplier":_vm.supplier}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }